import { red } from '@material-ui/core/colors'
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles'

import 'typeface-montserrat'
import 'typeface-source-sans-pro'

const fontFamily1 = ['Source Sans Pro'].join(',')

const fontFamily2 = ['Montserrat'].join(',')

const baseSpacing = 8

// A custom theme for this app
const theme = createMuiTheme({
  baseSpacing,
  palette: {
    text: {
      primary: '#2A223D',
    },

    primary: {
      main: '#184F7A',
      dark: '#2A223D',
    },
    secondary: {
      main: '#184F7A',
    },
    cta: {
      main: '#EA4C3C',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
      primary: '#FBFBFA',
      secondary: '#EBEDF1',
      accent: '#ccc',
      gray: '#C8C8C8',
      block: '#33357B',
      formBackground: '#f8f8f8',
    },
  },
  typography: {
    fontFamily: fontFamily1,

    h1: {
      fontFamily: fontFamily2,
    },

    h2: {
      fontFamily: fontFamily2,
      fontWeight: '700',
    },

    h3: {
      fontFamily: fontFamily2,
      fontWeight: '700',
      fontSize: '2rem',
    },

    h4: {
      fontFamily: fontFamily2,
      fontWeight: '600',
    },

    h5: {
      fontFamily: fontFamily2,
      fontSize: '1.15rem',
      fontWeight: '500',
    },

    h6: {
      fontFamily: fontFamily2,
      fontSize: '1.35rem',
      fontWeight: '700',
    },

    subtitle1: {
      fontSize: '1.3rem',
    },

    subtitle2: {
      textTransform: 'uppercase',
    },

    body2: {},

    button: {
      fontFamily: fontFamily2,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none', // no capitalize
        borderRadius: '5px',
      },
      // containedSecondary: {
      //   color: 'white',
      // },
    },
    // MuiCssBaseline: {
    //   '@global': {
    //     '@font-face': '...',
    //   },
    // },
    MuiFormLabel: {
      root: {
        lineHeight: '1.43em',
      },
    },
    MuiStepper: {
      root: {
        padding: 0,
      },
    },
  },
})

export default responsiveFontSizes(theme)
